/* src/app/core/dialog/dialog-template/dialog-template.component.scss */
.custom-muted {
  background-color: var(--tess-neutral-400);
}
.custom-white {
  background-color: var(--tess-neutral-0);
}
.dialog-overlay {
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0;
  transition: opacity 0.15s linear;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-overlay .dialog-container {
  display: flex;
  flex-direction: column;
  container-type: inline-size;
  margin: 0 auto;
  max-width: 56.25rem;
  width: 90%;
  max-height: 90vh;
  transform: translateY(1.25rem);
  transition: 300ms linear;
  transition-property: opacity, transform;
  opacity: 0;
}
.dialog-overlay .dialog-container .dialog-title-wrap {
  padding: 0 2.5rem;
  height: 3.75rem;
  margin-bottom: -0.1rem;
}
.dialog-overlay .dialog-container .dialog-title-wrap .dialog-title {
  color: var(--tess-neutral-850);
  align-self: center;
  text-transform: uppercase;
  font-family: var(--ff-montserrat);
  font-size: var(--tess-font-size-md);
  position: relative;
  letter-spacing: 0.2px;
  font-weight: var(--fw-semi-bold);
}
.dialog-overlay .dialog-container .dialog-title-wrap .dialog-title::before {
  position: absolute;
  content: "";
  bottom: -0.25rem;
  width: 1.9rem;
  height: 0.13rem;
  background-color: var(--tess-accent-400);
}
.dialog-overlay .dialog-container .dialog-title-wrap .close-button {
  color: var(--tess-neutral-825);
  right: 1.4rem;
  top: 1rem;
  font-size: var(--tess-font-size-lg);
  cursor: pointer;
  transition: transform 0.3s, color 0.2s;
}
.dialog-overlay .dialog-container .dialog-title-wrap .close-button:hover {
  transform: scale(1.3);
}
.dialog-overlay .dialog-container .dialog-content {
  padding: 2.5rem;
  height: 100%;
}
.dialog-overlay .dialog-container.add-link {
  max-width: 90%;
  width: 37.5rem;
  height: 41.44rem;
}
.dialog-overlay .dialog-container.new-page-dialog,
.dialog-overlay .dialog-container.new-hf-dialog {
  max-width: 90%;
  width: 68.75rem;
  height: 59.38rem;
}
.dialog-overlay .dialog-container.row-layout-dialog {
  width: 68.75rem;
  height: 49.88rem;
}
.dialog-overlay .dialog-container.add-structure-dialog {
  width: 42rem;
  max-width: calc(100vw - 2rem);
  max-height: calc(100dvh - 2rem);
}
.dialog-overlay .dialog-container.add-structure-dialog .dialog-content {
  min-height: 0;
  padding: 1.25rem;
}
.dialog-overlay .dialog-container.image-picker-dialog {
  height: 70vh;
  width: 100%;
  max-width: 70vw;
}
.dialog-overlay .dialog-container.new-widget-dialog {
  height: 43.75rem;
}
.dialog-overlay .dialog-container.new-widget-dialog .dialog-content {
  padding: 1.15rem 2.5rem;
  height: calc(100% - 6rem);
}
.dialog-overlay .dialog-container.icon-picker-dialog {
  height: 38.2rem;
}
.dialog-overlay .dialog-container.add-squire-link {
  width: 28.2rem;
}
.dialog-overlay .dialog-container.delete-page-dialog,
.dialog-overlay .dialog-container.revert-settings-dialog {
  width: 43.75rem;
  max-width: 70%;
  transition: opacity 0.2s 0.2s linear, transform 300ms ease-out;
}
.dialog-overlay .dialog-container.new-menu-item-dialog,
.dialog-overlay .dialog-container.delete-image-dialog {
  width: 31.25rem;
  max-width: 70%;
  transition: opacity 0.2s 0.2s linear, transform 300ms ease-out;
}
.dialog-overlay .dialog-container.font-picker {
  height: 96vh;
  max-height: 95vh;
  width: 90vw;
  max-width: 90vw;
}
.dialog-overlay .dialog-container.menu-modal {
  right: 0;
  top: 0;
  margin: unset;
  position: fixed !important;
  transform: none !important;
  max-width: unset;
  max-height: unset;
  height: 100%;
  width: 100%;
}
.dialog-overlay.animate-dialog {
  opacity: 1;
}
.dialog-overlay.animate-dialog .dialog-container {
  transform: translateY(0);
  opacity: 1;
}
.dialog-overlay.offset {
  z-index: 11;
}
.dialog-overlay.default {
  z-index: 960;
}
@media (width <= 60rem) {
  .dialog-overlay .dialog-container .dialog-content {
    padding: 1rem;
  }
  .dialog-overlay .dialog-container .dialog-title-wrap {
    padding: 0 1rem;
  }
  .dialog-overlay .dialog-container .dialog-title-wrap .close-button {
    right: 1rem;
  }
  .dialog-overlay .dialog-container.add-structure-dialog {
    width: 100%;
    max-width: calc(100vw - 1rem);
    max-height: calc(100dvh - 1rem);
  }
  .dialog-overlay .dialog-container.add-structure-dialog .dialog-content {
    padding: 1rem;
  }
}
/*# sourceMappingURL=dialog-template.component.css.map */
